module.exports = __webpack_public_path__ + "img/categorie-coquillages-famille-boutrais.670f9b94.webp";